import { render, staticRenderFns } from "./platformOrderBatch.vue?vue&type=template&id=d6d854ae&scoped=true&"
import script from "./platformOrderBatch.vue?vue&type=script&lang=js&"
export * from "./platformOrderBatch.vue?vue&type=script&lang=js&"
import style0 from "./platformOrderBatch.vue?vue&type=style&index=0&id=d6d854ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d854ae",
  null
  
)

export default component.exports